import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetBubbleRight: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12a9 9 0 01-9 9h-1l-7 3 2-5A9 9 0 1121 12z" />
      </svg>
    </div>
  );
};

export default WidgetBubbleRight;
